import {useEffect, useState} from "react";

const DesignHistoryLoadingMessage = ({color}) => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDots(prevDots => {
        if (prevDots === '') return '.';
        if (prevDots === '.') return '..';
        if (prevDots === '..') return '...';
        return '';
      });
    }, 500); // 0.5초마다 변경

    return () => clearInterval(intervalId);
  }, []);

  return <div style={{color: color || "#fff"}}>Loading your design history{dots}</div>;
};

export default DesignHistoryLoadingMessage;
